import { ENROLLMENT_LOADING_STATUS_UPDATE } from '../constants/actionTypes';

const initState = {
  enrollmentLoading: true,
};

function reportsLoadingStatuses(state = initState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case ENROLLMENT_LOADING_STATUS_UPDATE:
      return payload;
    default:
      return state;
  }
}

export default reportsLoadingStatuses;
